const EMAIL_REGEX = /^[^@]+@[^@]+\.[^@]+$/;

export function validateEmail(value: string) {
  return EMAIL_REGEX.test(value);
}
